/*
 * @Author: Chris 
 * @Date: 2022-07-28 10:58:42 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-10-24 14:28:53
 */
 
<template>
  <div class="menu">
    <div class="menu_userinfo">
      <div class="userinfo_left">
        <el-image
          class="left_img"
          :src="userMsg.headPortrait ? userMsg.headPortrait : Headerimg"
          alt=""
        />
      </div>
      <div class="userinfo_right">
        <div class="right_name">{{ userMsg.userName }}</div>
        <div v-for="item in userMsg.roles" :key="item.roleId">
          {{ item.roleName }}
        </div>
      </div>
    </div>
    <div class="menu_menu" v-if="show">
      <el-menu router :default-active="activeMenu" @select="selectM">
        <el-menu-item
          class="menu_menu_"
          v-for="index in MenuList"
          :key="index.path"
          :index="index.path"
        >
          <img
            class="icon"
            :src="
              activeMenu == index.path ? index.meta.icon[0] : index.meta.icon[1]
            "
            alt=""
          />
          <span slot="title">
            {{ index.meta.title }}
            <i class="el-icon-caret-right"></i>
          </span>
        </el-menu-item>

        <!-- 点击进入业务系统 -->

        <div class="menu_menu_SP" index="" @click="go()">
          <img class="icon" src="../../assets/IMG/menu/system_1.png" alt="" />
          <span slot="title">
            业务系统
            <i class="el-icon-caret-right SP"></i>
          </span>
        </div>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { asyncRouterMap } from "../../router/index";
import { userpersonalinformation, authmenuleftList } from "../../api/api";
import Headerimg from "../../assets/IMG/header/header_moren.png";
export default {
  name: "Menu",
  data() {
    return {
      userMsg: "", //用户信息
      activeMenu: "",
      show: false,
      MenuList: [],
      Headerimg: Headerimg,
    };
  },
  mounted() {
    this.MenuList = asyncRouterMap;
    this.activeMenu = this.$route.path;
    this.getUserMsg();
    this.getMenu();
  },

  methods: {
    /**
     * 页面跳转
     * */

    go() {
      let url =
        process.env.VUE_APP_BUSINESS +
        "/#/home?ump1=" +
        window.localStorage.getItem("UM_accessToken");
      window.open(url);
    },

    /**
     * 获取用户信息
     * */

    getUserMsg() {
      userpersonalinformation().then((res) => {
        if (res.code == 200) {
          this.userMsg = res.data;
          console.log('SET_User_Info:', res.data)
          this.$store.commit('SET_User_Info', res.data);

          let USER_IDENTITY = [];
          for (let i in res.data.roles) {
            USER_IDENTITY.push(res.data.roles[i].roleCode);
          }
          window.localStorage.setItem(
            "UM_USER_IDENTITY",
            JSON.stringify(USER_IDENTITY)
          );
        }
      });
    },

    /**
     * 获取菜单权限
     * */

    getMenu() {
      authmenuleftList().then((res) => {
        if (res.code == 200) {
          let arr = [];
          for (let i in this.MenuList) {
            for (let z in res.data) {
              if (res.data[z].menuId == this.MenuList[i].meta.menuId) {
                arr.push(this.MenuList[i]);
              }
            }
          }
          this.show = true;
          this.MenuList = arr;
        }
      });
    },

    /**
     * 菜单激活回调
     * */

    selectM(index, data) {
      this.activeMenu = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.menu {
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .menu_userinfo {
    height: 8.125rem;
    width: 100%;
    border-bottom: 0.125rem solid #eee;
    display: flex;
    align-items: center;
    justify-content: center;
    .userinfo_left {
      user-select: none;
      width: 3.625rem;
      height: 3.625rem;
      .left_img {
        width: 100%;
        height: 100%;
        border-radius: 0.25rem;
      }
    }
    .userinfo_right {
      user-select: none;
      height: 3.625rem;
      margin-left: 0.5rem;
      min-width: 5rem;
      font-weight: 400;
      font-size: 0.875rem;
      line-height: 1.375rem;
      color: #333333;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .right_name {
        margin-bottom: 0.25rem;
      }
    }
  }
  .menu_menu {
    color: #333333;
    margin-top: 2.25rem;
    .menu_menu_ {
      display: flex;
      align-items: center;
    }
    .icon {
      margin: 0 0.3125rem;
      width: 1rem;
      height: 1rem;
    }
  }

  .menu_menu_SP {
    display: flex;
    align-items: center;
    border-radius: 1.25rem;
    padding: 0 1.25rem !important;
    height: 1.875rem;
    margin-bottom: 1.5rem;
    font-size: 0.875rem;
    line-height: 1.375rem;
    .icon {
      margin: 0 0.3125rem;
      width: 1rem;
      height: 1rem;
    }
    .SP {
      margin-right: 5px;
      width: 24px;
      text-align: center;
      font-size: 18px;
      vertical-align: middle;
      color: #909399;
    }
  }
}

.menu :deep(.el-menu) {
  border-right: none;
  user-select: none;
  .el-menu-item.is-active {
    color: #fff;
    background-color: #b7282d !important;
    border-radius: 1.25rem;
    padding: 0 1.25rem !important;
    height: 1.875rem;
  }
  .el-menu-item {
    border-radius: 1.25rem;
    padding: 0 1.25rem !important;
    height: 1.875rem;
    margin-bottom: 1.5rem;
    font-size: 0.875rem;
    line-height: 1.375rem;
    line-height: 1.875rem;
  }

  .el-menu-item:focus,
  .el-menu-item:hover {
    background-color: rgba(204, 204, 204, 0.16);
  }
}
</style>